/* ============
 * Material Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  query: {
    page: 1,
    limit: 50,
    search: '',
    isSet: false,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/material/state.js